import { FC } from 'react';
import { clsx } from 'clsx';

import * as style from './style.css';
import { ArticleParagraph1, UIHeading3 } from '@cian/ui-kit';

interface ICardProps {
  card: { title: string; subtitle: string; className: string };
}

export const Card: FC<ICardProps> = ({ card: { title, subtitle, className } }) => {
  return (
    <div className={style['container']}>
      <div className={clsx(style['image'], style[className])}></div>
      <div className={style['title']}>
        {' '}
        <UIHeading3>{title}</UIHeading3>
      </div>
      <div className={style['subtitle']}>
        {' '}
        <ArticleParagraph1>{subtitle}</ArticleParagraph1>
      </div>
    </div>
  );
};
